import Ajv from 'ajv';
import schema from './schema.json';

// Copy process.env to avoid Webpack inlining json config files and requiring
// config.production.json while building
const env = Object.assign({}, process.env);

const defaults = require('./defaults.json');

let configFile;
switch (env.NODE_ENV) {
    case 'test':
    case 'ci':
        configFile = require(`./config.${env.NODE_ENV}.json`);
        break;
    default:
        // Webpack injected external module
        configFile = require('Config');
        break;
}

const ajv = new Ajv();
if (!ajv.validate(schema, configFile)) {
    throw new Error('Invalid configuration:\n' + JSON.stringify(ajv.errors, null, 4));
}

const config = Object.assign({}, defaults, env, configFile);

export default config;
